import { useState, useEffect } from 'react';
import Footer from '../../components/Footer/Footer';
import HeaderMain from '../../components/HeaderMain/HeaderMain';
import HeaderMobile from '../../components/HeaderMobile/HeaderMobile';
import { useTranslation } from 'react-i18next';
import styles from "./Terms.module.scss";

function Terms() {
  const [selectedTab, setSelectedTab] = useState("companyInfo");
  const [isMobile, setIsMobile] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const savedLanguage = localStorage.getItem('selectedLanguage') || 'en';

    if (i18n.language !== savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [i18n]);

  return (
    <>
      {isMobile ? (
        <HeaderMobile />
      ) : (
        <HeaderMain selectedTab={selectedTab} onTabChange={setSelectedTab} />
      )}

      <div className={styles.termsContainer}>
        <h3
          style={{
            color: '#000',
            fontSize: '29px',
            letterSpacing: '-1px',
            textAlign: 'center',
            paddingBottom: '22px',
            fontWeight: '600',
          }}
        >
          {t('termsOfUse.title')}
        </h3>
        <div
          dangerouslySetInnerHTML={{
            __html: `
              <style>
                h3 {
                  margin-top: 40px;
                  margin-bottom: 10px;
                }
                p {
                  margin-top: 5px;
                  margin-bottom: 5px;
                  font-size: 18px;
                }
                @media screen and (max-width: 768px) {
                  h3 {
                    margin-top: 30px;
                    font-size: 22px;
                  }
                  p {
                    font-size: 16px;
                  }
                }
              </style>
              ${t('termsOfUse.content')}
            `,
          }}
        ></div>
      </div>
      <Footer />
    </>
  );
}

export default Terms;
